import styled from 'styled-components'
const Wrapper = styled.div`


.custom-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.custom-modal {
    background: #fff;
    padding: 30px 25px;
    width: 90%;
    max-width: 420px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.custom-modal h3 {
    margin-top: 15px;
    font-weight: 600;
}

.custom-modal p {
    margin-top: 10px;
    color: #555;
    line-height: 1.5;
}

.success-icon {
    color: #28a745;
}

.error-icon {
    color: #dc3545;
}

.card-heading{
    color: #374151;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.bg-danger-cus{
    border-radius: 12px;
    border: 1px solid #FDE2E1;
    background: #FEF1F2;
}
.card-heading text-center{
    display: flex;
    justify-content: space-between;
}


@media (max-width: 768px) {
  .first-final-text{
    font-size: 14px !important;
    width: 6rem;
  }
    .first-final-icon svg{
      font-size : 1.2rem!important;
}
}

    .content-output-container{
        display: flex;
        justify-content: space-between;
        display: flex;
        padding: 10px;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #0067b6ff;
        box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
       background: linear-gradient(135deg, #d6f2ff, #9ed6f8, #69b6f0);

    }
        .content-output-text{
            display: flex;
            align-items: anchor-center;
            gap: 1rem;
        }
    .icons-actions{
    display: flex;
    gap: 2rem;
    }
    .first-final-icon {
        display: flex;
        padding: 11.5px;
        flex-direction: column;
        align-items: flex-start;
        gap: 3.75px;
        border-radius: 18.75px;
        background: #F3F3F3;ss
      }
    .first-final-icon svg{
        font-size : 1.5rem
    }

    .first-final-text{
        margin-bottom: 0;
    color: #374151;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    }

    .icons-actions svg{
        font-size : 1.2rem;
    }


    .icons-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.icon-with-label {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
  background-color: transparent;

  svg {
    font-size: 18px;
  }

  .icon-label {
    max-width: 0;
    opacity: 0;
    transition: max-width 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
    font-size: 17px;
    color: #333;
    white-space: nowrap;
    letter-spacing :1px;
  }

  &:hover .icon-label {
    max-width: 100px;
    opacity: 1;
  }

  &:hover {
    background-color: #f0f0f0;
  }
}

.translate-icon-group {
  position: relative;

  .down-arrow {
    font-size: 14px;
  }

  

 `
export default Wrapper